// src/pages/reports/SalesSummaryReport.jsx
import BaseReportPage from '../../components/reports/BaseReportPage'
import SalesSummaryFilters from '../../components/reports/SalesSummaryFilters'

const SalesSummaryReport = () => {
  const columns = [
    { key: 'orderNumber', label: 'Order #', type: 'text' },
    { key: 'customerName', label: 'Customer', type: 'text' },
    { key: 'branch', label: 'Branch', type: 'text' },
    { key: 'orderType', label: 'Type', type: 'text' },
    { key: 'paymentMethod', label: 'Payment', type: 'text' },
    { key: 'discount', label: 'Discount', type: 'currency' },
    { key: 'total', label: 'Total', type: 'currency' },
    { key: 'date', label: 'Date', type: 'date' },

  ]

  return (
    <BaseReportPage
      reportType="sales-summary"
      title="Sales Summary Report"
      columns={columns}
      dataKey="sales"
      enableFilters={true}
      customFilterComponent={SalesSummaryFilters}
    />
  )
}

export default SalesSummaryReport